import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { SEARCE_COLORS } from '../../../theme';
import { SKELETON_ANIMATION, skeletonTintSx } from './skeletonTokens';

export interface TableSkeletonProps {
  /** Number of pseudo-rows */
  rows?: number;
  /** Number of cell blocks per row */
  columns?: number;
  /** Row block height in px */
  rowHeight?: number;
}

/**
 * Generic data-table skeleton (grid of rounded bars).
 */
export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 8,
  columns = 6,
  rowHeight = 28,
}) => (
  <Box sx={{ p: 2, width: '100%' }} role="status" aria-label="Loading table">
    {Array.from({ length: rows }).map((_, r) => (
      <Box key={r} sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'center' }}>
        {Array.from({ length: columns }).map((_, c) => (
          <Skeleton
            key={c}
            variant="rounded"
            animation={SKELETON_ANIMATION}
            height={rowHeight}
            sx={{ flex: 1, minWidth: 48, ...skeletonTintSx }}
          />
        ))}
      </Box>
    ))}
  </Box>
);

export interface TableLoadingOverlayProps {
  rows?: number;
  columns?: number;
}

/**
 * Absolute overlay for an existing `TableContainer` while data is fetching.
 */
export const TableLoadingOverlay: React.FC<TableLoadingOverlayProps> = (props) => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      bgcolor: alpha(SEARCE_COLORS.background, 0.88),
      zIndex: 1,
      overflow: 'auto',
    }}
  >
    <TableSkeleton {...props} />
  </Box>
);
